module.exports = __webpack_public_path__ + "static/img/icon_info-1.32a7c6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/icon_info-1.svg
// module id = ckJm
// module chunks = 1